import { take, takeLatest, cancel, call, put, cancelled } from 'redux-saga/effects'

// Helper for api errors
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
let clientApi = axiosApi()

// Our login constants
import {
  LOGIN_MFA_REQUESTING,
  LOGIN_MFA_SUCCESS,
  LOGIN_MFA_ERROR,
  LOGIN_MFA_URL,
} from './constants'

let _history = {};
// So that we can modify our Client piece of state
import {
  setClient,
  parserToken
} from '../../client/actions'

import {
  CLIENT_UNSET,
} from '../../client/constants'

import { storedb } from '../../../views/client/storedb'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function loginMfaApi (formData) {
  const request = clientApi.post(LOGIN_MFA_URL, 
    {
      mfa_code: formData.mfa_code,
      username: parserToken(localStorage.getItem('tmp')).Username
    }
  );
  return handleRequest(request);
}

function* loginMfaFlow (formData) {
  let token
  try {
    var dbContext = storedb();
    // try to call to our loginApi() function.  Redux Saga
    // will pause here until we either are successful or
    // receive an error
    var result = yield call(loginMfaApi, formData)
    token = result.token
    var code = result.code
    if (code != 200) {
      yield put({ type: LOGIN_MFA_ERROR, error: result.message })
    } else {
      yield put(setClient(token))
      // set a stringified version of our token to localstorage on our domain
      localStorage.setItem('token', JSON.stringify(token))
      yield put({ type: LOGIN_MFA_SUCCESS, data: result })
      _history.push('/dashboard');
    }
    
  } catch (error) {
    // error? send it to redux
    yield put({ type: LOGIN_MFA_ERROR, error })
  }

  // return the token for health and wealth
  return token
}


// Our watcher (saga).  It will watch for many things.
function* loginMfaWatcher () {
  const { formData, history } = yield take(LOGIN_MFA_REQUESTING)
  _history = history;
  yield takeLatest(loginMfaFlow, formData)
}

export default loginMfaWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/LoginMfa/sagas.js